'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["slots", "slotProps", "className", "classes"];
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import IconButton from '@mui/material/IconButton';
import { ScrollToBottomAffordance } from '@mui/x-chat-headless';
import { styled, createUseThemeProps } from "../internals/zero-styled/index.mjs";
import { useChatScrollToBottomAffordanceUtilityClasses } from "./chatScrollToBottomAffordanceClasses.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
const useThemeProps = createUseThemeProps('MuiChatScrollToBottomAffordance');
const ChatScrollToBottomAffordanceStyled = styled(IconButton, {
  name: 'MuiChatScrollToBottomAffordance',
  slot: 'Root',
  overridesResolver: (_, styles) => styles.root
})(({
  theme
}) => ({
  position: 'absolute',
  bottom: theme.spacing(1),
  left: '50%',
  transform: 'translateX(-50%)',
  pointerEvents: 'auto',
  border: '1px solid',
  borderColor: (theme.vars || theme).palette.divider,
  backgroundColor: (theme.vars || theme).palette.background.paper,
  boxShadow: theme.shadows[2],
  fontSize: '1.25rem',
  transition: theme.transitions.create(['box-shadow', 'background-color'], {
    duration: theme.transitions.duration.short
  }),
  '@media (prefers-reduced-motion: reduce)': {
    transition: 'none'
  },
  '&:hover': {
    backgroundColor: (theme.vars || theme).palette.background.paper,
    boxShadow: theme.shadows[4]
  }
}));
function DefaultScrollToBottomIcon() {
  return /*#__PURE__*/_jsx("svg", {
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    style: {
      width: '1em',
      height: '1em'
    },
    children: /*#__PURE__*/_jsx("path", {
      d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
    })
  });
}
const ChatScrollToBottomAffordance = /*#__PURE__*/React.forwardRef(function ChatScrollToBottomAffordance(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiChatScrollToBottomAffordance'
  });
  const {
      slots,
      slotProps,
      className,
      classes: classesProp
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  const classes = useChatScrollToBottomAffordanceUtilityClasses(classesProp);
  return /*#__PURE__*/_jsx(ScrollToBottomAffordance, _extends({
    ref: ref
  }, other, {
    slots: _extends({
      root: ChatScrollToBottomAffordanceStyled,
      icon: DefaultScrollToBottomIcon
    }, slots),
    slotProps: _extends({}, slotProps, {
      root: _extends({
        size: 'small',
        className: clsx(classes.root, className)
      }, slotProps?.root)
    })
  }));
});
if (process.env.NODE_ENV !== "production") ChatScrollToBottomAffordance.displayName = "ChatScrollToBottomAffordance";
process.env.NODE_ENV !== "production" ? ChatScrollToBottomAffordance.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  classes: PropTypes.object,
  className: PropTypes.string,
  scrollBehavior: PropTypes.oneOf(['auto', 'instant', 'smooth']),
  slotProps: PropTypes.object,
  slots: PropTypes.object
} : void 0;
export { ChatScrollToBottomAffordance };